import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListOrdered = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M7.75 8.25h7.5m-7.5-3.5h10.5m-10.5 11.5h7.5m-7.5-3.5h10.5M4 9.25v-5.5L1.75 6m3.5 11.25h-3.5s2.75-2 3-3-.25-2-1.5-2-1.5 1-1.5 1.25"
	})]
});
const ForwardRef = forwardRef(SvgListOrdered);
export { ForwardRef as ReactComponent };
